module.exports = __webpack_public_path__ + "media/images/design/images/main_img-739d42a7f6c8724a1c8ac8dcc1266775.jpg";